<template>
  <el-dropdown-item v-bind="$attrs"><slot /></el-dropdown-item>
</template>
<script>
export default {
  name: 'RtDropdownItem',
  data() {
    return {};
  }
};
</script>



// WEBPACK FOOTER //
// rtDropdownItem.vue?6e4ce76c